import { Link, RichText, RichTextBlock } from 'prismic-reactjs';

export const hasRichText = (richtext?: RichTextBlock[]): boolean => !!RichText.asText(richtext ?? []);

export const hasLink = (link: Link): boolean => !!link?.url || !!link?.id;
